/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
const style: { [key: string]: React.CSSProperties } = {
  '.namespace': {
    opacity: '.7',
  },
  boolean: {
    color: 'var(--code-light-boolean-literal)',
  },
  char: {
    color: 'var(--code-light-string-literal)',
  },
  'code[class*="language-"]': {
    MozHyphens: 'none',
    MozTabSize: '4',
    OTabSize: '4',
    WebkitHyphens: 'none',
    color: '#d4d4d4',
    direction: 'ltr',
    fontFamily: 'var(--typography-code-font-family), monospace',
    fontSize: 'var(--typography-code-font-size)',
    fontWeight: 'var(--typography-code-font-weight)',
    hyphens: 'none',
    letterSpacing: '0',
    lineHeight: '1.25rem',
    msHyphens: 'none',
    tabSize: '4',
    textAlign: 'left',
    textShadow: 'none',
    whiteSpace: 'pre',
    wordBreak: 'normal',
    wordSpacing: 'normal',
  },
  comment: {
    color: 'var(--code-light-comment)',
  },
  function: {
    color: 'var(--code-light-function)',
  },
  'function.maybe-class-name': {
    color: 'var(--code-light-function)',
  },
  italic: {
    fontStyle: 'italic',
  },
  keyword: {
    color: 'var(--code-light-keyword)',
  },
  'keyword.control-flow': {
    color: 'var(--code-light-keyword)',
  },
  'keyword.module': {
    color: 'var(--code-light-keyword)',
  },
  number: {
    color: 'var(--code-light-number-literal)',
  },
  operator: {
    color: 'var(--code-light-operator)',
  },
  'pre[class*="language-"]': {
    MozHyphens: 'none',
    MozTabSize: '4',
    OTabSize: '4',
    WebkitHyphens: 'none',
    background: '#1e1e1e',
    color: '#d4d4d4',
    direction: 'ltr',
    fontFamily: 'var(--typography-code-font-family), monospace',
    fontSize: 'var(--typography-code-font-size)',
    fontWeight: 'var(--typography-code-font-weight)',
    hyphens: 'none',
    letterSpacing: '0',
    lineHeight: '1.25rem',
    margin: '.5em 0',
    msHyphens: 'none',
    overflow: 'auto',
    padding: '1em',
    tabSize: '4',
    textAlign: 'left',
    textShadow: 'none',
    whiteSpace: 'pre',
    wordBreak: 'normal',
    wordSpacing: 'normal',
  },
  prolog: {
    color: 'var(--code-light-comment)',
  },
  property: {
    color: 'var(--code-light-property)',
  },
  punctuation: {
    color: 'var(--code-light-operator)',
  },
  regex: {
    color: 'var(--code-light-operator)',
  },
  string: {
    color: 'var(--code-light-string-literal)',
  },
  variable: {
    color: 'var(--code-light-property)',
  },
};

export default style;
